"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientArgs = void 0;
var getClientArgs = function (_a) {
    var customerHash = _a.customerHash, path = _a.path;
    return ({
        headers: {
            'X-Recharge-Customer-Hash': customerHash || '',
            'X-Shopify-Domain': process.env.PERMANENT_DOMAIN || window.permanentDomain || '',
        },
        uri: (process.env.SUBSCRIPTIONS_API_URL || '') + path,
    });
};
exports.getClientArgs = getClientArgs;
